/* eslint-disable no-unused-vars */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";

const config = {
    phoneNumber: "01234567890",
    email: "enquiry@russellsparts.com",
};

const SupportPanelsComponent = () => {
    return (
        <div className="flex flex-col lg:flex-row gap-[15px] md:gap-[30px]">
            <div className="flex flex-1 flex-col gap-[15px] rounded-[10px] bg-brand-light-grey p-[15px] lg:p-[30px]">
                <div className="flex flex-row items-start gap-[15px] lg:flex-col">
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="min-w-[30px] max-w-[30px] lg:min-w-[40px] lg:max-w-[40px]"
                    >
                        <path
                            d="M25.7031 22.4121C26.5625 21.3184 28.0469 21.0059 29.2969 21.5528L38.0469 25.3028C39.4531 25.8496 40.2344 27.334 39.9219 28.8184L38.0469 37.5684C37.7344 38.9746 36.4062 39.9903 35 39.9903C34.4531 39.9903 33.9844 39.9903 33.5156 39.9903C33.2031 39.9903 32.8125 39.9903 32.4219 39.9121C14.2969 38.6621 0 23.5059 0 4.99027C0 3.58402 1.01562 2.2559 2.42188 1.9434L11.1719 0.0683978C12.6562 -0.244102 14.1406 0.537148 14.6875 1.9434L18.4375 10.6934C18.9844 11.9434 18.6719 13.4278 17.5781 14.2871L14.375 16.9434C16.4844 20.5371 19.4531 23.5059 23.0469 25.6153L25.7031 22.4121ZM35 37.4903C35.2344 37.4903 35.5469 37.334 35.5469 37.0215L37.4219 28.2715C37.5 27.959 37.3438 27.7246 37.1094 27.5684L28.3594 23.8184C28.0469 23.7403 27.8125 23.8184 27.5781 23.9746L25 27.1778C24.2188 28.1153 22.8906 28.3496 21.7969 27.7246C17.8125 25.459 14.5312 22.1778 12.2656 18.1934C11.6406 17.0996 11.875 15.7715 12.8125 14.9903L16.0156 12.4121C16.1719 12.1778 16.25 11.9434 16.1719 11.6309L12.4219 2.8809C12.2656 2.64652 12.0312 2.49027 11.7188 2.5684L2.96875 4.4434C2.65625 4.4434 2.5 4.7559 2.5 4.99027C2.5 22.959 17.0312 37.4903 34.9219 37.4903H35Z"
                            fill="#0061AF"
                        />
                        <path
                            d="M21.25 0C31.5625 0 40 8.4375 40 18.75C40 19.4531 39.375 20 38.75 20C38.0469 20 37.5 19.4531 37.5 18.75C37.5 9.84375 30.1562 2.5 21.25 2.5C20.5469 2.5 20 1.95312 20 1.25C20 0.625 20.5469 0 21.25 0ZM22.5 15C23.8281 15 25 16.1719 25 17.5C25 18.9062 23.8281 20 22.5 20C21.0938 20 20 18.9062 20 17.5C20 16.1719 21.0938 15 22.5 15ZM20 8.75C20 8.125 20.5469 7.5 21.25 7.5C27.4219 7.5 32.5 12.5781 32.5 18.75C32.5 19.4531 31.875 20 31.25 20C30.5469 20 30 19.4531 30 18.75C30 13.9844 26.0156 10 21.25 10C20.5469 10 20 9.45312 20 8.75Z"
                            fill="#61A60E"
                        />
                    </svg>

                    <div className="flex flex-col gap-[5px]">
                        <div className="flex flex-col gap-[5px]">
                            <h3 className="!mb-0 text-[18px] font-bold leading-[24px] text-brand-quaternary lg:text-[24px] lg:leading-[30px]">
                                Call 0345 456 6670
                            </h3>
                            <p className="!mb-0">
                                Call our friendly team on{" "}
                                <span className="font-bold">0345 456 6670</span>
                                . We are available 8am to 5pm Monday to Friday.
                            </p>
                        </div>

                        <a
                            href="tel:+443454566670"
                            className="content__support-panel-link font-bold !text-brand-black !no-underline"
                        >
                            Call Now <FontAwesomeIcon icon={faArrowRight} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="flex flex-1 flex-col gap-[15px] rounded-[10px] bg-brand-light-grey p-[15px] lg:p-[30px]">
                <div className="flex flex-row items-start gap-[15px] lg:flex-col">
                    <svg
                        width="40"
                        height="41"
                        viewBox="0 0 40 41"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="min-w-[30px] max-w-[30px] lg:min-w-[40px] lg:max-w-[40px]"
                    >
                        <path
                            d="M6.25 12.5H23.75C24.375 12.5 25 13.125 25 13.75C25 14.4531 24.375 15 23.75 15H6.25C5.54688 15 5 14.4531 5 13.75C5 13.125 5.54688 12.5 6.25 12.5ZM28.75 12.5H33.75C34.375 12.5 35 13.125 35 13.75C35 14.4531 34.375 15 33.75 15H28.75C28.0469 15 27.5 14.4531 27.5 13.75C27.5 13.125 28.0469 12.5 28.75 12.5ZM6.25 17.5H13.75C14.375 17.5 15 18.125 15 18.75C15 19.4531 14.375 20 13.75 20H6.25C5.54688 20 5 19.4531 5 18.75C5 18.125 5.54688 17.5 6.25 17.5ZM18.75 17.5H33.75C34.375 17.5 35 18.125 35 18.75C35 19.4531 34.375 20 33.75 20H18.75C18.0469 20 17.5 19.4531 17.5 18.75C17.5 18.125 18.0469 17.5 18.75 17.5Z"
                            fill="#61A60E"
                        />
                        <path
                            d="M15 32.5V36.25L22.6562 30.5469C23.0469 30.2344 23.5938 30 24.1406 30H35C36.3281 30 37.5 28.9062 37.5 27.5V5C37.5 3.67188 36.3281 2.5 35 2.5H5C3.59375 2.5 2.5 3.67188 2.5 5V27.5C2.5 28.9062 3.59375 30 5 30H12.5C13.8281 30 15 31.1719 15 32.5ZM5 0H35C37.7344 0 40 2.26562 40 5V27.5C40 30.3125 37.7344 32.5 35 32.5H24.1406L14.4531 39.7656C14.0625 40.0781 13.5938 40.0781 13.125 39.9219C12.7344 39.6875 12.5 39.2969 12.5 38.75V35V32.5H10H5C2.1875 32.5 0 30.3125 0 27.5V5C0 2.26562 2.1875 0 5 0Z"
                            fill="#0061AF"
                        />
                    </svg>

                    <div className="flex flex-col gap-[5px]">
                        <div className="flex flex-col gap-[5px]">
                            <h3 className="!mb-0 text-[18px] font-bold leading-[24px] text-brand-quaternary lg:text-[24px] lg:leading-[30px]">
                                Quick Enquiry
                            </h3>
                            <p className="!mb-0">
                                Fill out our Quick Enquiry form, or email us at{" "}
                                <a
                                    href={`mailto:info@russellsparts.com`}
                                    className="content__support-panel-link font-bold text-brand-black !underline"
                                >
                                    info@russellsparts.com
                                </a>
                                .
                            </p>

                            <button
                                data-testid="enquiry-form__open"
                                className="content__support-panel-link text-left font-bold text-brand-black !no-underline"
                            >
                                Quick Enquiry{" "}
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-1 flex-col gap-[15px] rounded-[10px] bg-brand-light-grey p-[15px] lg:p-[30px]">
                <div className="flex flex-row items-start gap-[15px] lg:flex-col">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#25D366"
                        className="min-w-[30px] max-w-[30px] lg:min-w-[40px] lg:max-w-[40px]"
                        viewBox="-1.66 0 740.824 740.824"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M630.056 107.658C560.727 38.271 468.525.039 370.294 0 167.891 0 3.16 164.668 3.079 367.072c-.027 64.699 16.883 127.855 49.016 183.523L0 740.824l194.666-51.047c53.634 29.244 114.022 44.656 175.481 44.682h.151c202.382 0 367.128-164.689 367.21-367.094.039-98.088-38.121-190.32-107.452-259.707m-259.758 564.8h-.125c-54.766-.021-108.483-14.729-155.343-42.529l-11.146-6.613-115.516 30.293 30.834-112.592-7.258-11.543c-30.552-48.58-46.689-104.729-46.665-162.379C65.146 198.865 202.065 62 370.419 62c81.521.031 158.154 31.81 215.779 89.482s89.342 134.332 89.311 215.859c-.07 168.242-136.987 305.117-305.211 305.117m167.415-228.514c-9.176-4.591-54.286-26.782-62.697-29.843-8.41-3.061-14.526-4.591-20.644 4.592-6.116 9.182-23.7 29.843-29.054 35.964-5.351 6.122-10.703 6.888-19.879 2.296-9.175-4.591-38.739-14.276-73.786-45.526-27.275-24.32-45.691-54.36-51.043-63.542-5.352-9.183-.569-14.148 4.024-18.72 4.127-4.11 9.175-10.713 13.763-16.07 4.587-5.356 6.116-9.182 9.174-15.303 3.059-6.122 1.53-11.479-.764-16.07-2.294-4.591-20.643-49.739-28.29-68.104-7.447-17.886-15.012-15.466-20.644-15.746-5.346-.266-11.469-.323-17.585-.323-6.117 0-16.057 2.296-24.468 11.478-8.41 9.183-32.112 31.374-32.112 76.521s32.877 88.763 37.465 94.885c4.587 6.122 64.699 98.771 156.741 138.502 21.891 9.45 38.982 15.093 52.307 19.323 21.981 6.979 41.983 5.994 57.793 3.633 17.628-2.633 54.285-22.19 61.932-43.616 7.646-21.426 7.646-39.791 5.352-43.617-2.293-3.826-8.41-6.122-17.585-10.714"
                        />
                    </svg>

                    <div className="flex flex-col gap-[5px]">
                        <div className="flex flex-col gap-[5px]">
                            <h3 className="!mb-0 text-[18px] font-bold leading-[24px] text-brand-quaternary lg:text-[24px] lg:leading-[30px]">
                                WhatsApp
                                <br />
                                07739 977 307
                            </h3>
                            <p className="!mb-0">
                                WhatsApp us on{" "}
                                <span className="font-bold">07739 977 307</span>
                                . We are available 8am to 5pm Monday to Friday
                            </p>
                        </div>

                        <a
                            href="https://wa.me/447739977307"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="content__support-panel-link font-bold !text-brand-black !no-underline"
                        >
                            WhatsApp Now <FontAwesomeIcon icon={faArrowRight} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportPanelsComponent;
